import {Component, Input, OnInit} from '@angular/core';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {UserNamespace} from '@namespaces/user.namespace';
import {RoutesStorage} from '@helpers/routes.helper';
import {EventsService} from '@services/events.service';
import {TechnicalDeviceApiService} from '@api/technical-device.api.service';
import {WorkingObjectTechnicalDevicePagesService} from '../../services/working-object-technical-device-pages.service';
import {AuthService} from '@services/auth.service';

@Component({
    selector: 'app-technical-device-list-item',
    templateUrl: './technical-device-list-item.component.html',
    styleUrls: ['./technical-device-list-item.component.scss']
})
export class TechnicalDeviceListItemComponent implements OnInit {

    @Input() device: TechnicalDeviceNamespace.ApiDataInterface;

    @Input() isFetching = false;

    permissions = UserNamespace.Permission;

    viewUrl: string;

    canView = false;

    constructor(
        private events: EventsService,
        private api: TechnicalDeviceApiService,
        private devicePagesService: WorkingObjectTechnicalDevicePagesService,
        private authService: AuthService,
    ) {
    }

    ngOnInit() {
        this.viewUrl = RoutesStorage.TechnicalDevice.view(this.device.id);

        this.canView = this.authService.hasPermissions([this.permissions.technicalDeviceView]);
    }

    onRemove() {
        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить техническое устройство?',
            confirmButtonTitle: 'Удалить'
        }).subscribe(() => {
            this.api.delete({
                id: this.device.id
            }).subscribe(() => {
                this.devicePagesService.updateItems();
            }, () => {

            });
        }, () => {

        });
    }
}
